<ng-container>
  @if (isGroupShareRecording && userHasJoinedShare) {
    <div class="recording-banner" data-testid="recording-banner">
      <span class="recording-msg">Recording in progress</span>
      <mat-icon class="recording-icon" svgIcon="START_RECORDING"></mat-icon>
    </div>
  }
</ng-container>
